import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { useAuth } from '../../core/useAuth';

export const KeycloakLogin = () => {
  const { login, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const loginStarted = useRef(false);

  const returnTo = location.state?.returnTo || '/dashboard/hosting';

  /*
	        Keep login only in useEffect.
		      Add a guard to prevent duplicate calls.
		          */
  useEffect(() => {
    /*
					auto-login only once
					       */
    /*
						   	  Without loginStarted,
							  	  React Strict Mode would trigger double redirects.
								  	 */
    if (!isLoading && !isAuthenticated && !loginStarted.current) {
      loginStarted.current = true;
      login({ state: { returnTo } });
    }
  }, [isLoading, isAuthenticated, login, returnTo]);

  if (isLoading) {
    return <div>Lade Login...</div>;
  }

  return (
    <div>
      <p>Login</p>
      <p>Weiterleitung an Identity Provider zur Authentifizierung</p>

      {/* fallback button if auto-login fails */}
      <button onClick={() => login({ state: { returnTo } })}>
        Mit Keycloak anmelden
      </button>
    </div>
  );
};
